import request from '@/utils/request'

/**
 * 获取拼团商品列表
 * @param {Object} params 查询参数 {shopId, prodNameLike, page, row}
 * @returns {Promise} 包含拼团商品列表的Promise
 */
export function getGroupList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.listAdminProductGroup',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 创建拼团商品
 * @param {Object} data 拼团商品数据
 * @returns {Promise} 操作结果的Promise
 */
export function createGroupProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.saveProductGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新拼团商品
 * @param {Object} data 拼团商品数据
 * @returns {Promise} 操作结果的Promise
 */
export function updateGroupProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.updateProductGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除拼团商品
 * @param {String} groupId 拼团商品ID
 * @returns {Promise} 操作结果的Promise
 */
export function deleteGroupProduct(groupId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.deleteProductGroup',
      method: 'post',
      data: { groupId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取拼团订单统计
 * @param {String} shopId 店铺ID
 * @returns {Promise} 包含统计数据的Promise
 */
export function getGroupOrderStats(shopId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.getGroupOrderStats',
      method: 'get',
      params: { shopId }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}